import { Grid } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import { Lock, Person } from "@material-ui/icons";
import { Field } from "formik";
import { TextField } from "formik-material-ui";
import React, { useRef } from "react";
import { queryCache, useMutation } from "react-query";
import { useHistory } from "react-router";

import { loginUser } from "../../services/auth/mutations";
import { QUERY_AUTH } from "../../services/auth/queries";
import AuthForm from "./AuthForm";

const initialValues = {
  identifier: "",
  password: "",
};

const validate = (values) => {
  const errors = {};

  if (!values.identifier) {
    errors.identifier = "Обязательное поле";
  } else if (!RegExp(/\S+@\S+\.\S+/).test(values.identifier)) {
    errors.identifier = "Invalid email address";
  }

  return errors;
};

const Login = () => {
  const history = useHistory();
  const [login, { error }] = useMutation(loginUser, {
    onSuccess: () => history.push("/tickets"),
  });

  const onSubmit = (payload) => login(payload);

  const bottomLinks = () => (
    <Typography
      style={{
        marginTop: 22,
        textAlign: "center",
      }}
      onClick={() => {
        queryCache.removeQueries(QUERY_AUTH.queryKey);
        history.push("/reset");
      }}
    >
      <span style={{ cursor: "pointer" }}>Забыли пароль?</span>
    </Typography>
  );

  const formRef = useRef();

  const handleEnterSubmit = (event) => {
    if (event.keyCode === 13) formRef.current.handleSubmit();
  };

  return (
    <AuthForm
      initialValues={initialValues}
      validate={validate}
      onSubmit={onSubmit}
      errorMessage={error && error.message}
      formTitle="Вход"
      bottomLinks={bottomLinks}
      submitBtnTitle="Войти"
      formRef={formRef}
    >
      <Grid container alignItems="flex-end">
        <Grid item style={{ marginRight: 15 }}>
          <Person />
        </Grid>
        <Grid item style={{ flexGrow: 1 }}>
          <Field
            component={TextField}
            name="identifier"
            type="email"
            label="E-mail"
            fullWidth
            onKeyDown={handleEnterSubmit}
          />
        </Grid>
      </Grid>
      <Grid container alignItems="flex-end" style={{ marginTop: 20 }}>
        <Grid item style={{ marginRight: 15 }}>
          <Lock />
        </Grid>
        <Grid item style={{ flexGrow: 1 }}>
          <Field
            component={TextField}
            type="password"
            label="Пароль"
            name="password"
            onKeyDown={handleEnterSubmit}
            fullWidth
          />
        </Grid>
      </Grid>
    </AuthForm>
  );
};

export default Login;
